import { Component } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { SubscriptionService } from "src/app/core/service/subscription.service";
import { SubscriptionDTO } from "src/app/data/schema/Subscriptions/SubscriptionDTO";

@Component({
    selector: "app-profile-privacy-policy",
    templateUrl: "./profile-privacy-policy.component.html",
    styleUrls: ["./profile-privacy-policy.component.scss"]
})
export class ProfilePrivacyPolicyComponent {
    public privacyPolicy: SafeUrl;

    constructor(
        private readonly subscriptionService: SubscriptionService,
        private readonly domSanitizer: DomSanitizer
    ) {
        this.subscriptionService.currentSubscription$.subscribe((s: SubscriptionDTO) => {
            // console.log(s);
            if (s?.settings?.privacyPolicyUrl) {
                this.privacyPolicy = this.domSanitizer.bypassSecurityTrustResourceUrl(s.settings.privacyPolicyUrl);
            }
        });
    }
}
